/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerUpdateMutationResponse, PromptConfigurationsControllerUpdatePathParams, PromptConfigurationsControllerUpdate400, PromptConfigurationsControllerUpdate401, PromptConfigurationsControllerUpdate403, PromptConfigurationsControllerUpdate404 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerUpdate";

function getPromptConfigurationsControllerUpdateUrl(id: PromptConfigurationsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/prompt-configurations/${id}` as const }  
  return res
}

/**
 * @summary Update a prompt configuration
 * {@link /api/v1/prompt-configurations/:id}
 */
export async function promptConfigurationsControllerUpdate(id: PromptConfigurationsControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptConfigurationsControllerUpdateMutationResponse, ResponseErrorConfig<PromptConfigurationsControllerUpdate400 | PromptConfigurationsControllerUpdate401 | PromptConfigurationsControllerUpdate403 | PromptConfigurationsControllerUpdate404>, unknown>({ method : "PATCH", url : getPromptConfigurationsControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}